/* AUTO GENERATED FILE. DO NOT MODIFY */
/* eslint-disable */
export type Maybe<T> = T | null;


/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** SCALARS */
  JSON: any;
};


export type App = {
   __typename?: 'App';
  setupRequired: Scalars['Boolean'];
  timezone: Scalars['String'];
};

export type BooleanField = IField & {
   __typename?: 'BooleanField';
  id?: Maybe<Scalars['ID']>;
  parent: ResourceReference;
  type: FieldType;
  value?: Maybe<Scalars['JSON']>;
};

export type BulkProductConnection = {
   __typename?: 'BulkProductConnection';
  edges: Array<BulkProductEdge>;
  pageInfo: PageInfo;
};

export type BulkProductEdge = {
   __typename?: 'BulkProductEdge';
  cursor: Scalars['String'];
  node: BulkProductRow;
};

export type BulkProductRow = SingleProductRow | ProductRow | VariantRow;

export type BulkProductVariantConnection = {
   __typename?: 'BulkProductVariantConnection';
  variants: ProductVariant;
};

export type BulkVariantEdge = {
   __typename?: 'BulkVariantEdge';
  node: BulkProductRow;
};

export type BundlesVerifyStatus = {
   __typename?: 'BundlesVerifyStatus';
  running: Scalars['Boolean'];
};

export type DateField = IField & {
   __typename?: 'DateField';
  id?: Maybe<Scalars['ID']>;
  parent: ResourceReference;
  type: FieldType;
  value?: Maybe<Scalars['JSON']>;
};

export type DeleteShopMetafield = {
   __typename?: 'DeleteShopMetafield';
  deletedId: Scalars['ID'];
};

export type DropdownField = IField & {
   __typename?: 'DropdownField';
  id?: Maybe<Scalars['ID']>;
  parent: ResourceReference;
  type: FieldType;
  value?: Maybe<Scalars['JSON']>;
};

export type Field = NeverField | BooleanField | StringField | IntField | TimeField | DateField | DropdownField;

export type FieldData = {
   __typename?: 'FieldData';
  id: Scalars['ID'];
  type: FieldType;
  title: Scalars['String'];
  values: Array<Field>;
};

/** Defines how a field maps to a Shopify metafield */
export type FieldDefinition = {
   __typename?: 'FieldDefinition';
  /** Select the list of dropdown values */
  dropDownValues?: Maybe<Array<Scalars['String']>>;
  /** A uniquie id generated for this resource */
  id: Scalars['ID'];
  /** Shopify key of the metafield */
  key: Scalars['String'];
  /** Shopify namespace of the metafield */
  namespace: Scalars['String'];
  /** The Shopify resource that this will be attatched to */
  resourceType: ResourceType;
  /** Shown by default in the app */
  shownByDefault: Scalars['Boolean'];
  /** Human readable identifier */
  title: Scalars['String'];
  /** The type of data it will store */
  type: FieldType;
};

export type FieldDefinitionConnection = {
   __typename?: 'FieldDefinitionConnection';
  edges: Array<FieldDefinitionEdge>;
  pageInfo: PageInfo;
};

export type FieldDefinitionEdge = {
   __typename?: 'FieldDefinitionEdge';
  node: FieldDefinition;
};

/** Payload to create a new FieldDefinition */
export type FieldDefinitionNew = {
  /** The type of data it will store */
  type: FieldType;
  /** Human readable identifier */
  title: Scalars['String'];
  /** The Shopify resource that this will be attatched to */
  resourceType: ResourceType;
  /** Shopify namespace of the metafield */
  namespace: Scalars['String'];
  /** Shopify key of the metafield */
  key: Scalars['String'];
  /** Shown by default in the app */
  shownByDefault?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Payload to update an existing FieldDefinition */
export type FieldDefinitionUpdate = {
  /** A uniquie id generated for this resource */
  id: Scalars['ID'];
  /** The type of data it will store */
  type?: Maybe<FieldType>;
  /** Human readable identifier */
  title?: Maybe<Scalars['String']>;
  /** Shown by default in the app */
  shownByDefault?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FieldInput = {
  metafieldId?: Maybe<Scalars['ID']>;
  definitionId: Scalars['ID'];
  type: FieldType;
  parent: InputResourceReference;
  value?: Maybe<Scalars['JSON']>;
};

/** Field Option */
export type FieldOptionNew = {
  /** field definition option value */
  title: Scalars['String'];
};

/** Describes the value stored in a field */
export enum FieldType {
  Never = 'NEVER',
  Boolean = 'BOOLEAN',
  String = 'STRING',
  Integer = 'INTEGER',
  Time = 'TIME',
  Date = 'DATE',
  Isodate = 'ISODATE',
  Dropdown = 'DROPDOWN',
  Dropdownmulti = 'DROPDOWNMULTI'
}

/** Describes Field Types in a Human Readable Way */
export type FieldTypeOption = {
   __typename?: 'FieldTypeOption';
  /** The associated type */
  type: FieldType;
  /** Human readable identifier */
  title: Scalars['String'];
  /** A description of how this type works, how it's stored in Shopify, etc. */
  description: Scalars['String'];
};

export type FieldTypeOptionConnection = {
   __typename?: 'FieldTypeOptionConnection';
  edges: Array<FieldTypeOptionEdge>;
  pageInfo: PageInfo;
};

export type FieldTypeOptionEdge = {
   __typename?: 'FieldTypeOptionEdge';
  node: FieldTypeOption;
};

export type IField = {
  id?: Maybe<Scalars['ID']>;
  parent: ResourceReference;
  type: FieldType;
};

export type InputResourceReference = {
  id: Scalars['ID'];
  type: ResourceType;
  productId?: Maybe<Scalars['ID']>;
};

/**
 * Response from an install request
 * will contain a redirect URL to
 * authenticate with
 */
export type Install = {
   __typename?: 'Install';
  redirect: Scalars['String'];
};

export type IntField = IField & {
   __typename?: 'IntField';
  id?: Maybe<Scalars['ID']>;
  parent: ResourceReference;
  type: FieldType;
  value?: Maybe<Scalars['JSON']>;
};


export type LegacyFieldDefinition = {
   __typename?: 'LegacyFieldDefinition';
  id: Scalars['ID'];
  type: FieldType;
  title: Scalars['String'];
  resourceType: ResourceType;
};

/**
 * Response from a login request,
 * will contain a redirect URL to
 * authenticate with
 */
export type Login = {
   __typename?: 'Login';
  /**
   * If the user is already logged in
   * to this store
   */
  authenticated: Scalars['Boolean'];
  /**
   * If the store being used to
   * login with is installed
   */
  installed: Scalars['Boolean'];
  /** Where to redirect the user to */
  redirect?: Maybe<Scalars['String']>;
};

/** Defines Shopify metafield definition */
export type MetafieldDefinition = {
   __typename?: 'MetafieldDefinition';
  /** Shopify key of the metafield definition */
  key: Scalars['String'];
  /** The name */
  name: Scalars['String'];
  /** Shopify namespace of the metafield definition */
  namespace: Scalars['String'];
  /** The owner type it will store */
  ownerType: OwnerType;
  /** The Shopify field type that this will be attatched to */
  type?: Maybe<MetafieldType>;
};

export type MetafieldDefinitionConnection = {
   __typename?: 'MetafieldDefinitionConnection';
  edges?: Maybe<Array<Maybe<MetafieldDefinitionEdge>>>;
  pageInfo: PageInfo;
};

export type MetafieldDefinitionEdge = {
   __typename?: 'MetafieldDefinitionEdge';
  node?: Maybe<MetafieldDefinitionListItem>;
};

export type MetafieldDefinitionListItem = {
   __typename?: 'MetafieldDefinitionListItem';
  /** A uniquie id generated for this resource */
  id: Scalars['ID'];
  /** Shopify key of the metafield definition */
  key: Scalars['String'];
  /** The name */
  name: Scalars['String'];
  /** Shopify namespace of the metafield definition */
  namespace: Scalars['String'];
  /** The owner type it will store */
  ownerType: OwnerType;
  /** The Shopify field type that this will be attatched to */
  type?: Maybe<MetafieldTypeName>;
};

/** Payload to create a new MetafieldDefinition */
export type MetafieldDefinitionNew = {
  /** Shopify key of the metafield definition */
  key: Scalars['String'];
  /** The name */
  name: Scalars['String'];
  /** Shopify namespace of the metafield definition */
  namespace: Scalars['String'];
  /** The owner type it will store */
  ownerType: OwnerType;
  /** The Shopify field type that this will be attatched to */
  type: MetafieldType;
};

export enum MetafieldType {
  SingleLineTextField = 'single_line_text_field',
  NumberInteger = 'number_integer'
}

export type MetafieldTypeName = {
   __typename?: 'MetafieldTypeName';
  name?: Maybe<MetafieldType>;
};

export type Mutation = {
   __typename?: 'Mutation';
  /** Starts a job to verify all bundles */
  bundlesVerifyStart: BundlesVerifyStatus;
  /** Delete resource fields in bulk */
  deleteBulkFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Create a new fieldDefinition */
  fieldDefinitionCreate: FieldDefinition;
  /** Delete a field definition */
  fieldDefinitionDelete: FieldDefinition;
  /** Update a fieldDefinition */
  fieldDefinitionUpdate: FieldDefinition;
  /** Insert Field options values */
  fieldOptionCreate: FieldDefinition;
  /**
   * Installs the app on a shopify store.
   * This is only possible with a Shopify
   * user account where the email matches
   * an admin user in Shopify.
   */
  install: Install;
  /**
   * Logs in the user via the provided
   * shop. Shopify account must have an
   * email that matches a user that has
   * a role of STAFF or higher
   */
  login: Login;
  /** Create a new metafieldDefinition */
  metafieldDefinitionCreate: MetafieldDefinition;
  /** Set the default notification email for the store */
  notificationEmailUpdate: Scalars['String'];
  /** Create a new shopMetafield */
  shopMetafieldCreate: ShopMetafield;
  /** Delete a shopMetafield */
  shopMetafieldDelete: DeleteShopMetafield;
  /** Update a shopMetafield */
  shopMetafieldUpdate: ShopMetafield;
  /** Update resource fields in bulk */
  updateBulkFields: Array<Field>;
  /** Creates a new user */
  userCreate: User;
  /**
   * Special route that will allow creation of
   * first admin user. Is only usable when no
   * admin users exist
   */
  userCreateInitial: User;
  /** Delete a user by id */
  userDelete: User;
  /** Updates existing user */
  userUpdate: User;
};


export type MutationBundlesVerifyStartArgs = {
  email?: Maybe<Scalars['String']>;
};


export type MutationDeleteBulkFieldsArgs = {
  fields: Array<FieldInput>;
};


export type MutationFieldDefinitionCreateArgs = {
  fieldDefinition: FieldDefinitionNew;
};


export type MutationFieldDefinitionDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationFieldDefinitionUpdateArgs = {
  fieldDefinition: FieldDefinitionUpdate;
};


export type MutationFieldOptionCreateArgs = {
  fieldOption: FieldOptionNew;
};


export type MutationInstallArgs = {
  shop: Scalars['String'];
  redirect?: Maybe<Redirect>;
};


export type MutationLoginArgs = {
  shop: Scalars['String'];
  redirect?: Maybe<Redirect>;
};


export type MutationMetafieldDefinitionCreateArgs = {
  metafieldDefinition: MetafieldDefinitionNew;
};


export type MutationNotificationEmailUpdateArgs = {
  email: Scalars['String'];
};


export type MutationShopMetafieldCreateArgs = {
  shopMetafield: ShopMetafieldNew;
};


export type MutationShopMetafieldDeleteArgs = {
  shopMetafield: ShopMetafieldDelete;
};


export type MutationShopMetafieldUpdateArgs = {
  shopMetafield: ShopMetafieldUpdate;
};


export type MutationUpdateBulkFieldsArgs = {
  fields: Array<FieldInput>;
};


export type MutationUserCreateArgs = {
  user: UserCreateInput;
};


export type MutationUserCreateInitialArgs = {
  email: Scalars['String'];
};


export type MutationUserDeleteArgs = {
  id: Scalars['String'];
};


export type MutationUserUpdateArgs = {
  user: UserUpdateInput;
};

export type NeverField = IField & {
   __typename?: 'NeverField';
  id?: Maybe<Scalars['ID']>;
  parent: ResourceReference;
  type: FieldType;
};

export enum OwnerType {
  Product = 'PRODUCT',
  Productvariant = 'PRODUCTVARIANT'
}

/** TO BE MOVED */
export type PageInfo = {
   __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
};

export type ProductRow = Row & {
   __typename?: 'ProductRow';
  id: Scalars['ID'];
  /** Should always be PRODUCT */
  type: RowType;
  thumbnail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  productId?: Maybe<Scalars['ID']>;
  variantId?: Maybe<Scalars['ID']>;
};

export type ProductVariant = {
   __typename?: 'ProductVariant';
  edges: Array<BulkVariantEdge>;
};

export type Query = {
   __typename?: 'Query';
  /** Get Product with all variants */
  GetVariants: BulkProductVariantConnection;
  app: App;
  /** Loads a list of Product and Variant rows for use in the bulk editor */
  bulkProducts: BulkProductConnection;
  /** Checks status of job to verify all bundles */
  bundlesVerifyStatus: BundlesVerifyStatus;
  /** Load a field definition by it's id */
  fieldDefinition: FieldDefinition;
  /** Load a list of FieldDefinitions */
  fieldDefinitions: FieldDefinitionConnection;
  /** Load a list of Field Type Options */
  fieldTypes: FieldTypeOptionConnection;
  /** Load fields based by definition for a list of resources */
  fieldsByRefs: Array<FieldData>;
  /** Load the field definitions for the store */
  legacyFieldDefinitions: Array<LegacyFieldDefinition>;
  me?: Maybe<User>;
  /** Load a list of MetafieldDefinitions */
  metafieldDefinitions: MetafieldDefinitionConnection;
  /** Default notification email address for the store */
  notificationEmail: Scalars['String'];
  /** Load a list of Product Types */
  productTypes: Array<Maybe<Scalars['String']>>;
  /** Load a list of Product Vendors */
  productVendors: Array<Maybe<Scalars['String']>>;
  /** Load a shop metafield by it's id */
  shopMetafield: ShopMetafield;
  /** Load a list of ShopMetafields */
  shopMetafields: ShopMetafieldConnection;
  /** Load a specific user */
  user: User;
  /** Load a list of users */
  users: UserConnection;
};


export type QueryGetVariantsArgs = {
  id: Scalars['ID'];
};


export type QueryBulkProductsArgs = {
  query?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
};


export type QueryFieldDefinitionArgs = {
  id: Scalars['ID'];
};


export type QueryFieldsByRefsArgs = {
  fieldIds: Array<Scalars['ID']>;
  refs: Array<InputResourceReference>;
};


export type QueryMetafieldDefinitionsArgs = {
  first: Scalars['Int'];
  namespace: Scalars['String'];
  ownerType: Scalars['String'];
};


export type QueryShopMetafieldArgs = {
  id: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};

/**
 * A redirect location for when logging
 * in or authenticating
 */
export type Redirect = {
  /**
   * Extension to redirect to. May include
   * path, query, and / or hash components
   */
  path: Scalars['String'];
  /** Select which base to redirect to */
  target?: Maybe<Target>;
};

export type ResourceReference = {
   __typename?: 'ResourceReference';
  id: Scalars['ID'];
  productId?: Maybe<Scalars['ID']>;
  type: ResourceType;
};

export enum ResourceType {
  Product = 'PRODUCT',
  Variant = 'VARIANT'
}

/** Defines user roles */
export enum Role {
  Admin = 'ADMIN',
  Staff = 'STAFF'
}

export type Row = {
  id: Scalars['ID'];
  type: RowType;
};

export enum RowType {
  SingleProduct = 'SINGLE_PRODUCT',
  Product = 'PRODUCT',
  Variant = 'VARIANT'
}

/** Defines user scopes */
export enum Scope {
  /** User must be able to read products */
  ReadProducts = 'READ_PRODUCTS',
  WriteProducts = 'WRITE_PRODUCTS'
}

/** Defines Shopify shop metafield */
export type ShopMetafield = {
   __typename?: 'ShopMetafield';
  /** Shopify description of the metafield */
  description: Scalars['String'];
  /** A uniquie id generated for this resource */
  id: Scalars['ID'];
  /** Shopify key of the metafield */
  key: Scalars['String'];
  /** Shopify namespace of the metafield */
  namespace: Scalars['String'];
  /** The Shopify resource that this will be attatched to */
  owner_resource: Scalars['String'];
  /** The type of data it will store */
  type: MetafieldType;
  /** The value */
  value: Scalars['String'];
};

export type ShopMetafieldConnection = {
   __typename?: 'ShopMetafieldConnection';
  edges?: Maybe<Array<Maybe<ShopMetafieldEdge>>>;
  pageInfo: PageInfo;
};

/** Payload to delete an existing ShopMetafield */
export type ShopMetafieldDelete = {
  id: Scalars['ID'];
};

export type ShopMetafieldEdge = {
   __typename?: 'ShopMetafieldEdge';
  node?: Maybe<ShopMetafield>;
};

/** Payload to create a new ShopMetafield */
export type ShopMetafieldNew = {
  /** Shopify key of the metafield */
  key: Scalars['String'];
  /** The value */
  value: Scalars['String'];
  /** The type of data it will store */
  type: MetafieldType;
  /** Shopify description of the metafield */
  description: Scalars['String'];
  /** Shopify namespace of the metafield */
  namespace: Scalars['String'];
  /** The Shopify resource that this will be attatched to */
  owner_resource: Scalars['String'];
};

/** Payload to update an existing ShopMetafield */
export type ShopMetafieldUpdate = {
  /** A uniquie id generated for this resource */
  id: Scalars['ID'];
  /** Shopify key of theu metafield */
  key: Scalars['String'];
  /** The value */
  value: Scalars['String'];
  /** The type of data it will store */
  type: MetafieldType;
  /** Shopify description of the metafield */
  description: Scalars['String'];
  /** Shopify namespace of the metafield */
  namespace: Scalars['String'];
  /** The Shopify resource that this will be attatched to */
  owner_resource: Scalars['String'];
};

export type SingleProductRow = Row & {
   __typename?: 'SingleProductRow';
  id: Scalars['ID'];
  variantId: Scalars['ID'];
  /** Should always be SINGLE_PRODUCT */
  type: RowType;
  thumbnail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  sku?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['ID']>;
};

/**
 * Called when loading the app,
 * when a redirect is required
 * to use the app it will be
 * provided
 */
export type Status = {
   __typename?: 'Status';
  redirect?: Maybe<Scalars['String']>;
};

export type StringField = IField & {
   __typename?: 'StringField';
  id?: Maybe<Scalars['ID']>;
  parent: ResourceReference;
  type: FieldType;
  value?: Maybe<Scalars['JSON']>;
};

export enum Target {
  App = 'APP',
  Admin = 'ADMIN'
}

export type TimeField = IField & {
   __typename?: 'TimeField';
  id?: Maybe<Scalars['ID']>;
  parent: ResourceReference;
  type: FieldType;
  value?: Maybe<Scalars['JSON']>;
};

/** A user of the App. Spans all stores */
export type User = {
   __typename?: 'User';
  /** Email of this user account */
  email: Scalars['String'];
  /** Unique ID of this user */
  id: Scalars['String'];
  /** Role of this user */
  role: Role;
};

export type UserConnection = {
   __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserCreateInput = {
  /** Email of the user */
  email: Scalars['String'];
  /** Role of this user */
  role: Role;
};

export type UserEdge = {
   __typename?: 'UserEdge';
  node: User;
};

export type UserUpdateInput = {
  /**
   * Id of user to update. If not present
   * will create a new user 
   */
  id: Scalars['String'];
  /** Email of the user */
  email: Scalars['String'];
  /** Role of this user */
  role: Role;
};

export type VariantRow = Row & {
   __typename?: 'VariantRow';
  id: Scalars['ID'];
  /** Should always be VARIANT */
  type: RowType;
  thumbnail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  sku?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['ID']>;
  variantId?: Maybe<Scalars['ID']>;
};

export type DeleteBulkFieldsMutationVariables = {
  fields: Array<FieldInput>;
};


export type DeleteBulkFieldsMutation = Pick<Mutation, 'deleteBulkFields'>;

export type LoadBulkFieldsQueryVariables = {
  fieldIds: Array<Scalars['ID']>;
  refs: Array<InputResourceReference>;
};


export type LoadBulkFieldsQuery = { fieldsByRefs: Array<(
    Pick<FieldData, 'id' | 'type' | 'title'>
    & { values: Array<(
      Pick<NeverField, 'id' | 'type'>
      & { parent: Pick<ResourceReference, 'id' | 'type'> }
    ) | (
      Pick<BooleanField, 'id' | 'type' | 'value'>
      & { parent: Pick<ResourceReference, 'id' | 'type'> }
    ) | (
      Pick<StringField, 'id' | 'type'>
      & { str: StringField['value'] }
      & { parent: Pick<ResourceReference, 'id' | 'type'> }
    ) | (
      Pick<IntField, 'id' | 'type'>
      & { int: IntField['value'] }
      & { parent: Pick<ResourceReference, 'id' | 'type'> }
    ) | (
      Pick<TimeField, 'id' | 'type'>
      & { interval: TimeField['value'] }
      & { parent: Pick<ResourceReference, 'id' | 'type'> }
    ) | (
      Pick<DateField, 'id' | 'type'>
      & { utc: DateField['value'] }
      & { parent: Pick<ResourceReference, 'id' | 'type'> }
    ) | (
      Pick<DropdownField, 'id' | 'type'>
      & { options: DropdownField['value'] }
      & { parent: Pick<ResourceReference, 'id' | 'type'> }
    )> }
  )> };

export type LoadBulkProductsQueryVariables = {
  query?: Maybe<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
};


export type LoadBulkProductsQuery = { bulkProducts: { edges: Array<(
      Pick<BulkProductEdge, 'cursor'>
      & { node: Pick<SingleProductRow, 'id' | 'type' | 'variantId' | 'thumbnail' | 'title' | 'sku'> | Pick<ProductRow, 'id' | 'type' | 'thumbnail' | 'title'> | Pick<VariantRow, 'id' | 'type' | 'thumbnail' | 'title' | 'sku' | 'productId'> }
    )>, pageInfo: Pick<PageInfo, 'hasNextPage' | 'hasPreviousPage'> } };

export type LoadFieldDefinitionsQueryVariables = {};


export type LoadFieldDefinitionsQuery = { fieldDefinitions: { edges: Array<{ node: Pick<FieldDefinition, 'id' | 'type' | 'title' | 'resourceType' | 'key' | 'namespace' | 'shownByDefault' | 'dropDownValues'> }> } };

export type UpdateBulkFieldsMutationVariables = {
  fields: Array<FieldInput>;
};


export type UpdateBulkFieldsMutation = { updateBulkFields: Array<(
    Pick<NeverField, 'id' | 'type'>
    & { parent: Pick<ResourceReference, 'id' | 'type' | 'productId'> }
  ) | (
    Pick<BooleanField, 'id' | 'type'>
    & { parent: Pick<ResourceReference, 'id' | 'type' | 'productId'> }
  ) | (
    Pick<StringField, 'id' | 'type'>
    & { parent: Pick<ResourceReference, 'id' | 'type' | 'productId'> }
  ) | (
    Pick<IntField, 'id' | 'type'>
    & { parent: Pick<ResourceReference, 'id' | 'type' | 'productId'> }
  ) | (
    Pick<TimeField, 'id' | 'type' | 'value'>
    & { parent: Pick<ResourceReference, 'id' | 'type' | 'productId'> }
  ) | (
    Pick<DateField, 'id' | 'type' | 'value'>
    & { parent: Pick<ResourceReference, 'id' | 'type' | 'productId'> }
  ) | (
    Pick<DropdownField, 'id' | 'type' | 'value'>
    & { parent: Pick<ResourceReference, 'id' | 'type' | 'productId'> }
  )> };

export type CreateUserMutationVariables = {
  user: UserCreateInput;
};


export type CreateUserMutation = { userCreate: Pick<User, 'id' | 'email' | 'role'> };

export type DeleteUserMutationVariables = {
  id: Scalars['String'];
};


export type DeleteUserMutation = { userDelete: Pick<User, 'id' | 'email' | 'role'> };

export type LoadUserQueryVariables = {
  id: Scalars['ID'];
};


export type LoadUserQuery = { user: Pick<User, 'id' | 'email' | 'role'> };

export type UpdateUserMutationVariables = {
  user: UserUpdateInput;
};


export type UpdateUserMutation = { userUpdate: Pick<User, 'id' | 'email' | 'role'> };

export type LoadUsersQueryVariables = {};


export type LoadUsersQuery = { users: { edges: Array<{ node: Pick<User, 'id' | 'email' | 'role'> }> } };

export type LoadFieldTypeOptionsQueryVariables = {};


export type LoadFieldTypeOptionsQuery = { fieldTypes: { edges: Array<{ node: Pick<FieldTypeOption, 'type' | 'title' | 'description'> }> } };

export type LoadDefinitionQueryVariables = {
  id: Scalars['ID'];
};


export type LoadDefinitionQuery = { fieldDefinition: Pick<FieldDefinition, 'id' | 'type' | 'title' | 'resourceType' | 'namespace' | 'key' | 'shownByDefault' | 'dropDownValues'> };

export type UpdateFieldDefinitionMutationVariables = {
  fieldDefinition: FieldDefinitionUpdate;
};


export type UpdateFieldDefinitionMutation = { fieldDefinitionUpdate: Pick<FieldDefinition, 'id' | 'type' | 'title' | 'resourceType' | 'namespace' | 'key' | 'shownByDefault' | 'dropDownValues'> };

export type LoadDefinitionsQueryVariables = {};


export type LoadDefinitionsQuery = { fieldDefinitions: { edges: Array<{ node: Pick<FieldDefinition, 'id' | 'type' | 'title' | 'resourceType' | 'namespace' | 'key'> }> } };

export type CreateFieldDefinitionMutationVariables = {
  fieldDefinition: FieldDefinitionNew;
};


export type CreateFieldDefinitionMutation = { fieldDefinitionCreate: Pick<FieldDefinition, 'id' | 'type' | 'title' | 'resourceType' | 'shownByDefault'> };

export type LoadFilterOptionsQueryVariables = {};


export type LoadFilterOptionsQuery = Pick<Query, 'productTypes' | 'productVendors'>;


      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "UNION",
        "name": "BulkProductRow",
        "possibleTypes": [
          {
            "name": "SingleProductRow"
          },
          {
            "name": "ProductRow"
          },
          {
            "name": "VariantRow"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Row",
        "possibleTypes": [
          {
            "name": "SingleProductRow"
          },
          {
            "name": "ProductRow"
          },
          {
            "name": "VariantRow"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "Field",
        "possibleTypes": [
          {
            "name": "NeverField"
          },
          {
            "name": "BooleanField"
          },
          {
            "name": "StringField"
          },
          {
            "name": "IntField"
          },
          {
            "name": "TimeField"
          },
          {
            "name": "DateField"
          },
          {
            "name": "DropdownField"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IField",
        "possibleTypes": [
          {
            "name": "NeverField"
          },
          {
            "name": "BooleanField"
          },
          {
            "name": "StringField"
          },
          {
            "name": "IntField"
          },
          {
            "name": "TimeField"
          },
          {
            "name": "DateField"
          },
          {
            "name": "DropdownField"
          }
        ]
      }
    ]
  }
};
      export default result;
    